/* eslint-disable @typescript-eslint/no-explicit-any */
import { atom } from "recoil";
import { recoilPersist } from "recoil-persist";
import { systemTheme } from "../contexts/Constants";

const { persistAtom } = recoilPersist({
  storage: localStorage,
  key: "app",
});


export type AppTypes = {
  estate?: string,
  company?: string,
  isAuth?: boolean,
  base_api?: string,
  estate_code?: string,
  company_database?: string,
  theme?: "light" | "dark" | "system",
  remember?: { email: string, password: string } | undefined,
}

export default atom<AppTypes>({
  key: "app",
  default: {
    isAuth: false,
    theme: systemTheme,
    estate: "ESTATE PLUS ESTATE",
  },
  effects_UNSTABLE: [persistAtom],
});